"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIdSwiper = _interopRequireDefault(require("react-id-swiper"));
require("swiper/css/swiper.css");
var _resizeObserverPolyfill = _interopRequireDefault(require("resize-observer-polyfill"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _userflow = require("../../utils/userflow");
var _Throbber = _interopRequireDefault(require("../Throbber"));
var _excluded = ["imageHeight", "images", "emptyMessage", "onClickGallery", "id"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ArrowIcon = function ArrowIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 14.9L37 65l-21 50.1"
  }));
};
ArrowIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 53 130",
  fill: "none",
  stroke: "#fff",
  strokeWidth: "3",
  strokeLinecap: "round"
};
var settings = {
  direction: 'vertical',
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-custom-next',
    prevEl: '.swiper-button-custom-prev'
  },
  renderPrevButton: function renderPrevButton() {
    return /*#__PURE__*/_react["default"].createElement(StyledArrowIcon, {
      className: "swiper-button-custom-prev",
      type: "prev"
    });
  },
  renderNextButton: function renderNextButton() {
    return /*#__PURE__*/_react["default"].createElement(StyledArrowIcon, {
      className: "swiper-button-custom-next",
      type: "next"
    });
  },
  shouldSwiperUpdate: true,
  // TODO: не работает из-за direction: 'vertical' и watchSlidesVisibility: true
  lazy: {
    loadPrevNext: true,
    preloaderClass: 'swiper-lt-preloader',
    loadPrevNextAmount: 2
  },
  watchSlidesVisibility: true
};
var VerticalGallery = /*#__PURE__*/function (_React$PureComponent) {
  function VerticalGallery(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, VerticalGallery);
    _this = _callSuper(this, VerticalGallery, [props]);
    _this.wrapperRef = /*#__PURE__*/_react["default"].createRef();
    _this.state = {
      slidesPerView: 'auto'
    };
    return _this;
  }
  (0, _inherits2["default"])(VerticalGallery, _React$PureComponent);
  return (0, _createClass2["default"])(VerticalGallery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.observer = new _resizeObserverPolyfill["default"](this.calculateItemsToShow.bind(this));
      this.observer.observe(this.container);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.observer) {
        this.observer.unobserve(this.container);
      }
    }
  }, {
    key: "container",
    get: function get() {
      return (0, _get2["default"])(this, 'wrapperRef.current');
    }
  }, {
    key: "containerHeight",
    get: function get() {
      return (0, _get2["default"])(this.container, 'clientHeight');
    }
  }, {
    key: "calculateItemsToShow",
    value: function calculateItemsToShow() {
      var _this2 = this;
      var containerHeight = this.containerHeight;
      var imageHeight = this.props.imageHeight;
      var slidesPerView = containerHeight / imageHeight;
      setTimeout(function () {
        return _this2.setState({
          slidesPerView: slidesPerView
        });
      }, 17);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        imageHeight = _this$props.imageHeight,
        images = _this$props.images,
        emptyMessage = _this$props.emptyMessage,
        onClickGallery = _this$props.onClickGallery,
        id = _this$props.id,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var slidesPerView = this.state.slidesPerView;
      return /*#__PURE__*/_react["default"].createElement(StyledContainer, (0, _extends2["default"])({}, rest, {
        ref: this.wrapperRef
      }), (0, _isEmpty2["default"])(images) ? emptyMessage : /*#__PURE__*/_react["default"].createElement(StyledWrapper, {
        height: this.containerHeight
      }, /*#__PURE__*/_react["default"].createElement(_reactIdSwiper["default"], (0, _extends2["default"])({}, settings, {
        slidesPerView: slidesPerView
      }), images.map(function (image) {
        return /*#__PURE__*/_react["default"].createElement(StyledGaleryItem, {
          className: "swiper-lazy",
          height: imageHeight,
          "data-background": (0, _userflow.getFullUrl)(image),
          key: image,
          onClick: function onClick() {
            return onClickGallery(id);
          }
        }, /*#__PURE__*/_react["default"].createElement(_Throbber["default"], {
          className: "swiper-lt-preloader"
        }));
      }))));
    }
  }]);
}(_react["default"].PureComponent);
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "VerticalGallery__StyledContainer",
  componentId: "sc-v0zm4j-0"
})(["position:relative;height:100%;"]);
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "VerticalGallery__StyledWrapper",
  componentId: "sc-v0zm4j-1"
})(["position:absolute;width:100%;.swiper-container-vertical{height:", ";}"], function (props) {
  return "".concat(props.height, "px");
});
var StyledArrowIcon = (0, _styledComponents["default"])(ArrowIcon).withConfig({
  displayName: "VerticalGallery__StyledArrowIcon",
  componentId: "sc-v0zm4j-2"
})(["position:absolute;cursor:pointer;height:70px;width:30px;left:calc(50% - 15px);z-index:10;transform:rotate(", ");top:", ";bottom:", ";&.swiper-button-disabled{opacity:0.35;cursor:auto;pointer-events:none;}"], function (props) {
  return props.type === 'prev' ? '-90deg' : '90deg';
}, function (props) {
  return props.type === 'prev' ? '-15px' : 'auto';
}, function (props) {
  return props.type === 'next' ? '-15px' : 'auto';
});
VerticalGallery.propTypes = {
  imageHeight: _propTypes["default"].number.isRequired,
  images: _propTypes["default"].arrayOf(_propTypes["default"].string),
  emptyMessage: _propTypes["default"].node,
  className: _propTypes["default"].string
};
VerticalGallery.defaultProps = {
  className: '',
  images: [],
  emptyMessage: null
};
var StyledGaleryItem = _styledComponents["default"].div.withConfig({
  displayName: "VerticalGallery__StyledGaleryItem",
  componentId: "sc-v0zm4j-3"
})(["width:100%;height:", " !important;vertical-align:top;background-color:#f5f3f2;background-size:cover;"], function (props) {
  return "".concat(props.height, "px");
});
var _default = exports["default"] = VerticalGallery;